var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"filter filter--block",class:{ 'mb-4': _vm.need_margin },on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }